import React from "react";
import Container from "../common/Container";
import { HiGift, HiShieldCheck, HiGlobeAlt, HiUserGroup, HiLightBulb, HiCube } from "react-icons/hi";

const features = [
  {
    icon: HiCube,
    title: "NFT-Powered Fundraising",
    description:
      "Raise funds for your scientific projects through NFT crowdfunding and auctions. Contributors receive unique NFT tokens representing their support and ownership stake.",
    gradient: "from-primary to-[#7e7cff]",
  },
  {
    icon: HiUserGroup,
    title: "Research Communities",
    description:
      "Create and join scientific communities with shared interests. Token-gated access, collaborative research spaces, and community-driven funding for aligned projects.",
    gradient: "from-primary-green to-[#0dcada]",
  },
  {
    icon: HiLightBulb,
    title: "Research Results Discovery",
    description:
      "Publish and discover research outputs including datasets, algorithms, technical reports, and open-access tools. Tokenize your intellectual contributions.",
    gradient: "from-[#7e7cff] to-primary",
  },
  {
    icon: HiShieldCheck,
    title: "Blockchain Transparency",
    description:
      "All transactions and funding allocations are recorded on-chain. Immutable records ensure accountability, trust, and verifiable ownership of contributions.",
    gradient: "from-primary to-primary-green",
  },
  {
    icon: HiGlobeAlt,
    title: "Multi-Chain Support",
    description:
      "Deploy and interact across multiple EVM-compatible networks including Ethereum, Polygon, Arbitrum, Optimism, and BNB Chain for lower fees and faster transactions.",
    gradient: "from-[#0dcada] to-primary-green",
  },
  {
    icon: HiGift,
    title: "Rewards & Royalties",
    description:
      "Earn rewards for your contributions to the ecosystem. Project creators receive ongoing royalties from secondary NFT sales in the marketplace.",
    gradient: "from-primary-green to-primary",
  },
];

const FeaturesSection = () => {
  return (
    <section className="w-full py-20 lg:py-28 bg-gradient-to-b from-whitesmoke to-white relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary-green/20 to-transparent"></div>
      <div className="absolute top-1/3 -left-40 w-96 h-96 bg-primary/5 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-1/3 -right-40 w-80 h-80 bg-primary-green/5 rounded-full blur-[100px] pointer-events-none"></div>

      <Container className="relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Platform Features
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-secondary abel-font mb-4">
            Everything You Need to Fund Science
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            FunDeSci provides a complete ecosystem for decentralized scientific research funding and collaboration
          </p>
        </div>

        {/* Features Grid - 3x2 layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white/80 backdrop-blur-xl rounded-2xl p-8 border border-white/20 hover:border-primary/30 transition-all duration-300 hover:shadow-xl hover:shadow-primary/10 hover:-translate-y-2"
            >
              {/* Icon */}
              <div
                className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}
              >
                <feature.icon className="text-white" size={28} />
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-secondary mb-3 abel-font">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default FeaturesSection;
